import { Link } from 'react-router-dom';
import { editingStandards, principles } from '@/mocks/site';

export default function PrinciplesSection() {
  return (
    <section className="border-y border-background-200 bg-background-100" aria-labelledby="principles-title">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">核实方法</p>
            <h2 id="principles-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              我们是怎么核一条料的
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              核实不是表态，而是一套可复用的流程。同一条料，我们希望不同的人按这套方法都能得到接近的结论。
            </p>

            <div className="mt-6 rounded-xl border border-background-300 bg-background-50 p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950">核实编辑标准</h3>
              <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                {editingStandards.map((s) => (
                  <li key={s} className="flex items-start gap-2">
                    <span className="mt-1 w-4 h-4 flex items-center justify-center text-primary-500 shrink-0">
                      <i className="ri-arrow-right-s-line"></i>
                    </span>
                    {s}
                  </li>
                ))}
              </ul>
              <Link
                to="/debunk"
                className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                查看辟谣与核实方法
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="rounded-xl border border-background-200 bg-background-50 p-5">
                  <span className="flex w-10 h-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 text-lg">
                    <i className={p.icon}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}